import Axios from 'axios'

import { SERVER_BASE_URL } from '../baseUrl'

export const getProfileVisiteur = async (token: string) => {
  try {
    if (!token) return
    const response = await Axios.get(`${SERVER_BASE_URL}api/profileVisiteur/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
